"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownUnit = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
"c1pdmfej";
const CountdownUnit = exports.CountdownUnit = /*#__PURE__*/(0, _react.styled)("div")({
  name: "CountdownUnit",
  class: "c19iok9w"
});